import { render } from "./MdTablePagination.vue?vue&type=template&id=89dafeb8"
import script from "./MdTablePagination.vue?vue&type=script&lang=babel"
export * from "./MdTablePagination.vue?vue&type=script&lang=babel"

import "./MdTablePagination.vue?vue&type=style&index=0&id=89dafeb8&lang=scss"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.2.41_vue@3.5.14_typescript@5.5.4__webpack@5.99.8/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__